import React from 'react';
import css from './style.module.scss';

function Card1() {
  return <div className={css.loader}> </div>;
}

export default Card1;
